import { lazy } from "react"

export const Calendar = lazy(() => import("./calendar"))
